import React from 'react';
import { CoffeeIcon, CreditCardIcon, ShieldCheckIcon, TvIcon, WifiIcon, WrenchIcon } from 'lucide-react';
import { photos } from '../data/site';
const amenities = [{
  icon: WifiIcon,
  title: 'Free guest Wi-Fi',
  copy: 'Work or stream while you wait in the customer lounge.'
}, {
  icon: TvIcon,
  title: 'TV & coffee bar',
  copy: 'A comfortable waiting room with TV and coffee while we work.'
}, {
  icon: WrenchIcon,
  title: 'Modern diagnostic equipment',
  copy: 'Up-to-date, cutting-edge tooling backed by FCA Chrysler, Dodge and Jeep factory training.'
}, {
  icon: ShieldCheckIcon,
  title: '1 year / 12,000 mile warranty',
  copy: 'Parts and labor covered on the repairs we perform.'
}, {
  icon: CreditCardIcon,
  title: 'Financing through Snap',
  copy: 'Ask us about financing options when a repair is larger than expected.'
}, {
  icon: CoffeeIcon,
  title: 'Straight answers, every visit',
  copy: 'You will always know what we found, what it costs, and what can wait.'
}];
export function ShopExperience() {
  return <section id="shop-experience" className="w-full bg-chalk py-20 lg:py-28" data-id="element-175" data-mp="3o6qzmlfxekqo">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-176" data-mp="3a6g8dhapf44z">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,520px)] lg:items-center lg:gap-16" data-id="element-177" data-mp="3a817lk7yrb96">
          <div data-id="element-178" data-mp="3e9cwfnj0jsgb">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-179" data-mp="5s01lnml6g04">
              The shop
            </p>
            <h2 className="mt-4 max-w-[520px] font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink sm:text-[42px]" data-id="element-180" data-mp="aprtwir5844u">
              A shop built around the customer, not just the car
            </h2>
            <p className="mt-5 max-w-[540px] text-[16.5px] leading-relaxed text-steel/75" data-id="element-181" data-mp="z6sknk34li8">
              Over 55 years of combined technician experience, modern equipment
              and a waiting room you will not mind sitting in.
            </p>

            <ul className="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-2" data-id="element-182" data-mp="13dkreppksnf2">
              {amenities.map(item => <li key={item.title} className="flex gap-3.5" data-id="element-183" data-mp="zcr49yjyjcn8">
                  <item.icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-dark" aria-hidden="true" data-id="element-184" data-mp="ucctw9uvvqm1" />
                  <div data-id="element-185" data-mp="pda05lkct6td">
                    <h3 className="font-display text-[16px] font-bold tracking-tight text-ink" data-id="element-186" data-mp="pfw99pmw7udp">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-[14px] leading-relaxed text-steel/70" data-id="element-187" data-mp="fmx692qng1ak">
                      {item.copy}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 lg:gap-5" data-id="element-188" data-mp="6kxq0cngl18o">
            <figure className="sm:col-span-2" data-id="element-189" data-mp="1mme7wdlsgnt">
              <img src={photos.building} alt="Exterior of the East End Automotive Repair building in Oak Ridge, Tennessee" className="aspect-[16/9] w-full rounded-lg object-cover" data-id="element-190" data-mp="3su8mk2b9p7b0" />
              <figcaption className="mt-2.5 text-[13px] text-steel/60" data-id="element-191" data-mp="3nodbzmrwd02i">
                274 Warehouse Rd, Oak Ridge — updated exterior photos coming
                soon.
              </figcaption>
            </figure>
            <img src={photos.clipboard} alt="Technician reviewing a service inspection sheet" className="aspect-[4/3] w-full rounded-lg bg-white object-cover" data-id="element-192" data-mp="1hoipkjy4ncl" />
            <img src={photos.truck} alt="Truck being repaired in the service bay" className="aspect-[4/3] w-full rounded-lg object-cover" data-id="element-193" data-mp="34wsv3i14mg4x" />
          </div>
        </div>
      </div>
    </section>;
}